module.exports = __webpack_public_path__ + "static/media/community-gardens-sm-1.b1719218.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/community-gardens/community-gardens-sm-1.jpg
// module id = 4085
// module chunks = 13